import React, { Component } from 'react';
import { IReducerState } from '../../states/renditionStates';
import { connect } from 'react-redux';
import * as asyncStateAction from '../../actions/asyncStateAction';
import servicesConfig from '../../services/servicesConfig';
import * as HTML_RENDITION from '../../utils/general/general';
import Loading from '../../utils/animation/loading';
import shortid from 'shortid';
import Ellipsis from '../../utils/general/Ellipsis';
import { enterKeyPressed } from '../../utils/general/enterKey';
import moment from "moment";
import _, { isEmpty } from 'lodash';
import {localI18nData} from "../../utils/general/resourceBundleServices";
import { urlCopyFunc } from './../../utils/api/appControl';
// import {RenditionLoadable} from '../../../js/utils/general/LoadableRelated';
import RenditionUrlGenerator from '../../utils/api/renditionUrlGenerator';
import '../../../style/newRebranding/features/stacks.scss';

const _HTML_RENDITION: any = window.HTML_RENDITION;

interface IRelatedReportsProps {
    initialData: any;
    docHeaderJsonData: any;
    stacksRelatedResearchData: any;
    applyRelatedReportsData: () => {};
    showOldBranding: boolean;
    menuCode: any;
}

export class RelatedResearch extends Component<IRelatedReportsProps, any> {

    constructor(props: IRelatedReportsProps) {
        super(props);
        props.applyRelatedReportsData();  
    }

    public async openDocument(e: any, stackTypoe: string, docId: string, parentDocId: string, docUrl: string){
        if (e) {
            e.preventDefault();
        }
     
        if (_.isEmpty(docId)) {
            return;
        }

        if (HTML_RENDITION.isBloomBerg()) {
            let docLinkUrl = HTML_RENDITION.getDocumentLink(Base64.encode('doc_id=' + docId))
            docLinkUrl = RenditionUrlGenerator.URL_GENERATOR.environments(window.HTML_RENDITION.initialData.environment) + HTML_RENDITION.addParentDocDataParam(docLinkUrl);
            console.log('BloomBerg Related Reserch :: openDocument ::docId::docUrl::', docId, docLinkUrl);
            HTML_RENDITION.BloomBergExecutionWithDocId(docId, docLinkUrl, true);
            return;
        }

        const environment = window.HTML_RENDITION.initialData.environment;
        const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
        if (_.isEmpty(docUrl)) {
            docUrl = await asyncStateAction.fetchRenditionLink(servicesConfig.GET_RENDITION_LINK, docId)
        }

        if (HTML_RENDITION.isThirdPartyTokenAuthorization()) {
            HTML_RENDITION.tokenAuthorizationForThirdParty(docUrl);
            return;
        }
        const updatedDocUrl = !HTML_RENDITION.isCV2Link(docUrl) ? HTML_RENDITION.getCVFrameUrl(this.props.menuCode, docUrl, 'all_research') : docUrl;
        window.open(updatedDocUrl, HTML_RENDITION.setTargetValue(updatedDocUrl));
    }

    public enterKeyPressedFn = (e: any,stackCode: string, docId: string, parentDocId: string, docLinkUrl: string) => {
        const code = e.keyCode || e.which;
        if (code === 13 || code === 32) {
            this.openDocument(e, stackCode, docId, parentDocId, docLinkUrl);
        }
    }

    public stackContent(data: any, stacktype: string) {
        const docs: Array<any> = [];
        const dataLength = data.length >= 3 ? 3 : data.length; 
        for (let idx = 0; idx < dataLength; idx++) {
            const result = data[idx];
            const docId = result.relatedPublicationId || '';
            const headline = result.relatedPubDistHeadline || '';
            const publicationDate = result.relatedPubDate || '';
            const moment = require('moment-timezone')
            const start = moment.tz(publicationDate, "UTC")
            const docDate =start.tz("America/New_York").format("D MMM YYYY");
            const docLinkUrl = result.relatedPubUrl || '';
            
            const doc = [];
            doc.push(
                <div className='research' key={idx + 'research'}>
                    <div className='titleBlock' title={headline}>
                        <a tabIndex={0} className='headlineTitle'
                           role="link"
                           onClick={(e) => this.openDocument(e, stacktype, docId, _HTML_RENDITION.parent_doc_id, docLinkUrl)}
                           onKeyPress={(e) => this.enterKeyPressedFn(e, stacktype, docId, _HTML_RENDITION.parent_doc_id, docLinkUrl)}
                        >
                            <Ellipsis line={2}><span className='headlineText'>{headline}</span></Ellipsis>
                        </a>
                    </div>
                    <div className='docDate'>{docDate}</div>
                </div>);
            docs.push(doc);
        }

        return <div key={shortid.generate()}>{docs}</div>;
    }

    // public loadBranding() {
    //     let Branding: any;
    //     if (this.props.showOldBranding) {
    //       Branding = RenditionLoadable({
    //         loader: () => import('../../../dynamicComponents/stacksOld'),
    //       }, "stacksOld", Date.now());
    //     }
    //     else {
    //       Branding = RenditionLoadable({
    //         loader: () => import('../../../dynamicComponents/stacksNew'),
    //       }, "stacksNew", Date.now());
    //     }
    
    //     return <Branding/>;
    //   }
    
    public render() {
        const { docHeaderJsonData, stacksRelatedResearchData } = this.props;
        const i18n = localI18nData(docHeaderJsonData.metadata.isJP).data;
        const relatedResearchTitle = i18n.RelatedResearch;
        const relatedPublications = _.get(stacksRelatedResearchData,"data.publications[0].relatedPublications",[]);
        const pubFromRDESource = _.filter(relatedPublications,{relatedPubSource: "RDE"});
        const pubFromAuthorSource = _.filter(relatedPublications,{relatedPubSource: "AUTHOR"});
        const pubsToshow = !_.isEmpty(pubFromAuthorSource) ? pubFromAuthorSource : pubFromRDESource;
        return (
            <React.Fragment>
                {/* {this.loadBranding()} */}
                {
                    !_.isEmpty(pubsToshow) && <div key={shortid.generate()} id='whats_trending_stacks'>
                        <div className="whats-trending-part" key={"whats-trending-part"}>
                            <div key={"whats-trending"} className={'stack_title whats-trending_title'}>
                                <span className='stack_name'>{relatedResearchTitle}</span>
                            </div>
                            {this.stackContent(pubsToshow, 'relatedReports')}
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData,
        initialData: state.asyncStateReducer.initialData,
        stacksRelatedResearchData: state.asyncStateReducer.stacksRelatedResearchData,
        menuPaneStatus: state.commonStateReducer.menuPaneStatus,
        menuCode: state.commonStateReducer.menuCode,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        applyRelatedReportsData: () => dispatch(asyncStateAction.fetchStacksData(servicesConfig.GET_RELATED_RESEARCH_STACKS, 'RELATEDRESEARCH')),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RelatedResearch);